import { Field } from 'ngx-angular-query-builder';
import { FilterOperators, FieldMetadataCollection, FilterFieldProvider } from '@common/filter/filtering';
import { WidgetConfiguration } from '@feature/widget-configs';

export class AdminCallsWidgetFilterFieldProvider implements FilterFieldProvider {

  private readonly fieldMetaDataCollection = new FieldMetadataCollection();

  constructor(widgetConfig: WidgetConfiguration) {

    const addFilter = (label: string,
      optionsName: string,
      type: string,
      ops: string[]) => this.fieldMetaDataCollection.addFilter(label, optionsName, type, ops);

    addFilter('Call Reference', 'SystemCallReference', 'number', FilterOperators.AdminScalar);
    addFilter('Logged Date', 'SystemLoggedDate', 'date', FilterOperators.AdminDateDefaults);
    addFilter('Property Ref', 'SystemPropertyRef', 'number', FilterOperators.AdminScalar);
    addFilter('Unit Ref', 'SystemUnitRef', 'number', FilterOperators.AdminScalar);
    addFilter('Unit Address (Strung)', 'SystemUnitAddress', 'string', FilterOperators.AdminStringDefaults);
    addFilter('Lease Ref', 'SystemLeaseRef', 'number', FilterOperators.AdminScalar);
    addFilter('Tenant Ref', 'SystemTenantRef', 'number', FilterOperators.AdminScalar);
    addFilter('Tenant Name', 'SystemTenantName', 'string', FilterOperators.AdminStringDefaults);
    addFilter('Reply Email', 'SystemReplyEmail', 'string', FilterOperators.AdminStringDefaults);
    addFilter('Notified', 'SystemNotified', 'string', FilterOperators.AdminStringDefaults);
    addFilter('Subject', 'SystemSubject', 'string', FilterOperators.AdminStringDefaults);
    addFilter('Message', 'SystemMessage', 'string', FilterOperators.AdminStringDefaults);
    addFilter('Attached Documents', 'SystemAttachedDocuments', 'string', FilterOperators.AdminStringDefaults);
    addFilter('Comments', 'SystemComments', 'string', FilterOperators.AdminStringDefaults);
    addFilter('Status', 'SystemStatus', 'string', FilterOperators.AdminStringDefaults);
    addFilter('Closed Date', 'SystemClosedDate', 'date', FilterOperators.AdminDateDefaults);
  }

  getFilterFields(): Array<Field> {
    return this.fieldMetaDataCollection.getFilterFields();
  }

  getFieldNameFromLabel(label: string): string {
    return this.fieldMetaDataCollection.getFieldNameFromLabel(label);
  }

  getFilterField(fieldName: string): Field {
    return this.fieldMetaDataCollection.getFilterField(fieldName);
  }


}
